import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import ar from "./ar.json";
import darija from "./darija.json";
import type { Lang } from "@/lib/types";

export const SUPPORTED_LANGS: Lang[] = ["fr", "ar", "darija"];

const STORAGE_KEY = "levelcare:lang";

function detectInitialLang(): Lang {
  if (typeof window === "undefined") return "fr";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGS.includes(stored as Lang)) return stored as Lang;
  const nav = window.navigator.language.toLowerCase();
  if (nav.startsWith("ar")) return "ar";
  return "fr";
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    ar: { translation: ar },
    darija: { translation: darija },
  },
  lng: detectInitialLang(),
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLang(lang: Lang): void {
  i18n.changeLanguage(lang);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang === "darija" ? "fr" : lang; // darija romanisé reste latin
  }
}

if (typeof window !== "undefined") {
  document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = i18n.language === "darija" ? "fr" : i18n.language;
}

export default i18n;
